module.exports = __webpack_public_path__ + "img/cargando.ffd08bb4.gif";